<div fxLayout="row wrap" fxLayoutGap="15px" class="forms-container">

    <div class="consent-card" *ngFor="let consent of notifications; let i = index"
         [style.animation-delay]="(i * 0.1) + 's'">

        <!-- Card Header with gradient based on form type -->
        <div class="card-header"
             [ngClass]="{
                'header-consent': consent.form_type_id === 1,
                'header-declaration': consent.form_type_id === 2,
                'header-survey': consent.form_type_id === 4
             }">

            <!-- Form Type Icon -->
            <div class="form-type-icon">
                <mat-icon *ngIf="consent.form_type_id === 1">verified_user</mat-icon>
                <mat-icon *ngIf="consent.form_type_id === 2">description</mat-icon>
                <mat-icon *ngIf="consent.form_type_id === 4">poll</mat-icon>
            </div>

            <div class="header-content">
                <h3 class="card-title" [matTooltip]="consent.title">
                    {{ consent.title | slice:0:50 }}{{consent.title.length > 50 ? '...' : ''}}
                </h3>
                <div class="deadline-badge">
                    <mat-icon>schedule</mat-icon>
                    <span>{{consent.deadline ? consent.deadline : 'Χωρίς προθεσμία'}}</span>
                </div>
            </div>
        </div>

        <!-- Card Body -->
        <div class="card-body">
            <p class="card-description">
                {{ consent.description | slice:0:100 }}{{consent.description.length > 100 ? '...' : ''}}
            </p>
        </div>

        <!-- Card Footer -->
        <div class="card-footer">
            <button (click)="showConsent(child, consent)" mat-flat-button class="view-btn">
                <mat-icon>visibility</mat-icon>
                <span>Προβολή</span>
            </button>
        </div>

        <!-- Decorative corner accent -->
        <div class="corner-accent"></div>
    </div>

</div>
